<template>
  <ion-card
    v-if="!isLoading"
    color="light"
    class="border-default no-shadow spacing-xs filter-card ion-no-margin"
  >
    <h1 class="font-md bold-medium">{{ t('invoices.billingDetails') }}</h1>
    <div class="d-flex flex-column gap-xs mt-xs">
      <div>
        <p class="bold-medium grey font-sm">{{ t('invoices.name') }}</p>
        <p class="font-sm mt-sm">{{ profileBillingDataForm.name }}</p>
      </div>
      <div>
        <p class="bold-medium grey font-sm">{{ profileBillingDataForm.documentType }}</p>
        <p class="font-sm mt-sm">{{ profileBillingDataForm.documentId }}</p>
      </div>
      <div>
        <p class="bold-medium grey font-sm">{{ t('invoices.billingAddress') }}</p>
        <p class="font-sm mt-sm">{{ profileBillingDataForm.Location.fullAddress }}</p>
      </div>
      <div>
        <p class="bold-medium grey font-sm">{{ t('invoices.email') }}</p>
        <p class="font-sm mt-sm">{{ profileBillingDataForm.email }}</p>
      </div>
    </div>
  </ion-card>
  <div v-else>
    <SkeletonLoaderCard :width="'100%'" />
  </div>
</template>

<script setup lang="ts">
  import { onMounted, ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { IonCard } from '@ionic/vue';
  import { storeToRefs } from 'pinia';
  import { useBookingStore } from '@/stores/booking-store';
  import { useToast } from '@/composables/useToast';
  import SkeletonLoaderCard from '../loaders/SkeletonLoaderCard.vue';

  const { t } = useI18n();

  const { profileBillingDataForm } = storeToRefs(useBookingStore());
  const { getTenantBillingData } = useBookingStore();
  const { showToast } = useToast();

  const isLoading = ref(false);

  const handleGetProfileBillingData = async () => {
    try {
      isLoading.value = true;
      await getTenantBillingData();
    } catch (error) {
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    } finally {
      isLoading.value = false;
    }
  };

  const initialConfig = () => {
    handleGetProfileBillingData();
  };

  onMounted(() => {
    initialConfig();
  });
</script>
